import {css} from 'lit';
export const styles = css`:host {
  display: block;
}
`;
export default styles;
